<div class="container custom-section">
  <tan-alert-message
    *ngIf="quoteCart.length > 0"
    [errorType]="'warning'"
    [message]="'You can now add additional units.'"
  >
  </tan-alert-message>
  <div class="row mt-2">
    <div class="col-sm-12">
      <span class="section-heading">Select Configurations</span>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8 col-sm-12">
      <ng-container>
        <form class="mt-2" [formGroup]="purchaseForm">
          <div class="row mt-2">
            <div class="col-md-6 col-sm-12">
              <tan-loader
                [loading]="fpProjectCategoryLoading$ | async"
                [loadingText]="'<p>Loading Building types</p>'"
              >
              </tan-loader>

              <div
                class="row justify-content-center"
                *ngIf="fpProjectCategoryError$ | async"
              >
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message
                    [errorType]="'error'"
                    [message]="'Could not retrieve Building types'"
                  >
                  </tan-alert-message>
                </div>
              </div>

              <div
                class="form-group"
                *ngIf="
                  !(fpProjectCategoryLoading$ | async) &&
                  !(fpProjectCategoryError$ | async)
                "
              >
                <label class="control-label" for="project_category"
                  >Building type</label
                >
                <select
                  class="form-control"
                  formControlName="project_category"
                  id="project_category"
                  (change)="setFpProjectCategory()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option
                    *ngFor="let cat of fpProjectCategories"
                    [ngValue]="cat"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-6" *ngIf="selectedFpProjectCategory">
              <tan-loader
                [loading]="fpProjectSubCategoryLoading$ | async"
                [loadingText]="'<p>Loading Categories</p>'"
              >
              </tan-loader>

              <div
                class="row justify-content-center"
                *ngIf="fpProjectSubCategoryError$ | async"
              >
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message
                    [errorType]="'error'"
                    [message]="'Could not retrieve Categories'"
                  >
                  </tan-alert-message>
                </div>
              </div>

              <div
                class="form-group"
                *ngIf="
                  !(fpProjectSubCategoryLoading$ | async) &&
                  !(fpProjectSubCategoryError$ | async)
                "
              >
                <label class="control-label" for="project_sub_category"
                  >Category</label
                >
                <select
                  class="form-control"
                  formControlName="project_sub_category"
                  id="project_sub_category"
                  (change)="setFpProjectSubCategory()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option
                    *ngFor="let cat of fpProjectSubCategories"
                    [ngValue]="cat"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row mt-2" *ngIf="selectedFpProjectSubCategory">
            <div
              class="col-sm-12 col-md-6"
              *ngIf="selectedFpProjectSubCategory"
            >
              <tan-loader
                [loading]="fpProjectSizeLoading$ | async"
                [loadingText]="'<p>Loading Available sizes</p>'"
              >
              </tan-loader>

              <div
                class="row justify-content-center"
                *ngIf="fpProjectSizeError$ | async"
              >
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message
                    [errorType]="'error'"
                    [message]="'Could not retrieve matching sizes'"
                  >
                  </tan-alert-message>
                </div>
              </div>

              <div
                class="form-group"
                *ngIf="
                  !(fpProjectSizeLoading$ | async) &&
                  !(fpProjectSizeError$ | async)
                "
              >
                <label class="control-label" for="project_size">Size</label>
                <select
                  class="form-control"
                  formControlName="project_size"
                  id="project_size"
                  (change)="setFpProjectSize()"
                >
                  <option [ngValue]="null">Please select</option>

                  <option *ngFor="let size of fpProjectSizes" [ngValue]="size">
                    {{ size.size }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-6" *ngIf="selectedFpProjectSize">
              <tan-loader
                [loading]="extrasLoading"
                [loadingText]="'<p>Loading Variations</p>'"
              >
              </tan-loader>

              <div
                class="row justify-content-center"
                *ngIf="fpProjectExtrasError$ | async"
              >
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message
                    [errorType]="'error'"
                    [message]="'Could not retrieve variations'"
                  >
                  </tan-alert-message>
                </div>
              </div>

              <div class="form-group" *ngIf="displayExtras">
                <label class="control-label" for="project_extra"
                  >Variation option</label
                >
                <select
                  class="form-control"
                  formControlName="project_extra"
                  id="project_extra"
                  (change)="setFpProjectExtra()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option
                    *ngFor="let extra of fpProjectExtras"
                    [ngValue]="extra"
                  >
                    {{ extra.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row mt-2" *ngIf="showQty">
            <div class="col-sm-12 col-md-6">
              <div class="form-group">
                <label class="control-label" for="quantity">* Quantity</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="quantity"
                  [value]="unitQty"
                  (ngModelChange)="setUnitQty()"
                  min="0"
                  oninput="validity.valid||(value='');"
                />
                <span
                  class="error"
                  *ngIf="
                    purchaseForm.get('quantity').touched &&
                    purchaseForm.get('quantity').errors?.required
                  "
                >
                  Quantity is required</span
                >
              </div>
            </div>
          </div>
          <ng-container *ngIf="showProjectsTable && qtyEntered">
            <tan-loader
              [loading]="fpProjectListLoading$ | async"
              [loadingText]="'<p>Fetching projects</p>'"
            >
            </tan-loader>

            <div
              class="row justify-content-center"
              *ngIf="
                !(fpProjectListLoading$ | async) &&
                (fpProjectListError$ | async)
              "
            >
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-alert-message
                  [errorType]="'error'"
                  [message]="'Could not retrieve variations'"
                >
                </tan-alert-message>
              </div>
            </div>

            <div
              class="row justify-content-center"
              *ngIf="
                !(fpProjectListLoading$ | async) &&
                !(fpProjectListError$ | async) &&
                projects.length == 0
              "
            >
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-alert-message
                  [errorType]="'info'"
                  [message]="
                    'Could not retrieve variations that match criteria'
                  "
                >
                </tan-alert-message>
              </div>
            </div>

            <div
              class="form-group"
              *ngIf="
                !(fpProjectListLoading$ | async) &&
                !(fpProjectListError$ | async) &&
                projects.length > 0
              "
            >
              <label class="control-label" for="template_option"
                >Template Option</label
              >
              <select
                class="form-control"
                formControlName="template_option"
                id="template_option"
                (change)="setTemplateOption()"
              >
                <option [ngValue]="null">Please select</option>
                <option
                  *ngFor="let proj of projects"
                  [ngValue]="proj.floorplannerProjectId"
                >
                  {{ proj.name }}
                </option>
              </select>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              !(fpProjectListLoading$ | async) &&
              !(fpProjectListError$ | async) &&
              projects.length > 0 &&
              showTemplateOption
            "
          >
            <div class="row">
              <label class="col-sm-12 col-form-label">
                You have selected the below option:
              </label>
            </div>
            <div class="row mb-2">
              <div class="col-sm-9">
                {{ selectedTemplateOption.name }}
              </div>
              <div class="col-sm-3 ar">
                <div class="d-inline-block">
                  <button
                    class="btn btn-secondary table-filter-btn"
                    id="viewItem"
                    (click)="viewItem()"
                  >
                    <span class="fa fa-eye text-white"></span> View
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="showTemplateOption && hasShipping">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="transport_load_one"
                    >* Transport Option</label
                  >
                  <select
                    class="form-control"
                    formControlName="transport_load_one"
                    id="transport_load_one"
                    (change)="setSelectedTransportLoadOne()"
                  >
                    <option [ngValue]="null">Please select</option>
                    <option
                      *ngFor="let size of transportLoads"
                      [ngValue]="size.id"
                    >
                      {{ size.size }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="transport_load_one_qty"
                    >* Qty of Trucks required</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="transport_load_one_qty"
                    [value]="loadOneQty"
                    (change)="setSelectedTransportLoadOne()"
                  />
                  <span
                    class="error"
                    *ngIf="
                      purchaseForm.get('transport_load_one_qty').touched &&
                      purchaseForm.get('transport_load_one_qty').errors
                        ?.required
                    "
                  >
                    Qty is required</span
                  ><br />
                </div>
              </div>
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-loader
                  [loading]="transportOneLoading"
                  [loadingText]="'<p>Calculating charges..</p>'"
                >
                </tan-loader>
              </div>

              <div class="col-sm-12 d-flex justify-content-center">
                <div
                  class="row justify-content-center"
                  *ngIf="
                    !transportOneLoading &&
                    !transportOneHasPricing &&
                    selectedTransportLoadOne?.load &&
                    selectedTransportLoadOne?.quantity
                  "
                >
                  <div class="col-sm-12 d-flex justify-content-center">
                    <tan-alert-message
                      [errorType]="'error'"
                      [message]="'No transport found for selected truck size'"
                    >
                    </tan-alert-message>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="showTemplateOption && hasShipping && addSecondTransportLoad"
          >
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="transport_load_two"
                    >* Transport option</label
                  >
                  <select
                    class="form-control"
                    formControlName="transport_load_two"
                    id="transport_load_two"
                    (change)="setSelectedTransportLoadTwo()"
                  >
                    <option [ngValue]="null">Please select</option>
                    <option
                      *ngFor="let size of transportLoads"
                      [ngValue]="size.id"
                    >
                      {{ size.size }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label" for="transport_load_two_qty"
                    >* Qty of Trucks required</label
                  >
                  <input
                    type="number"
                    class="form-control"
                    formControlName="transport_load_two_qty"
                    [value]="loadTwoQty"
                    (change)="setSelectedTransportLoadTwo()"
                  />
                  <span
                    class="error"
                    *ngIf="
                      purchaseForm.get('transport_load_two_qty').touched &&
                      purchaseForm.get('transport_load_two_qty').errors
                        ?.required
                    "
                  >
                    Qty is required</span
                  ><br />
                </div>
              </div>
              <div class="col-sm-12 d-flex justify-content-center">
                <tan-loader
                  [loading]="transportTwoLoading"
                  [loadingText]="'<p>Calculating charges..</p>'"
                >
                </tan-loader>
              </div>

              <div
                class="row justify-content-center"
                *ngIf="
                  !transportTwoLoading &&
                  !transportTwoHasPricing &&
                  selectedTransportLoadTwo?.load &&
                  selectedTransportLoadTwo?.quantity
                "
              >
                <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message
                    [errorType]="'error'"
                    [message]="'No transport found for selected truck size'"
                  >
                  </tan-alert-message>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="row" *ngIf="showTemplateOption && hasShipping">
            <div class="col-sm-12">
              <span class="guidance-text"><strong>Note:</strong></span
              ><br />
              <span class="guidance-text"
                >1. A single 3m/6m building could be transported on a 6m
                truck</span
              ><br />
              <span class="guidance-text"
                >2. A single 9m/12m building could be transported on a 12m
                truck</span
              ><br />
              <span class="guidance-text"
                >3. Two 6m buildings can be transported on a 12m truck</span
              ><br />
              <span class="guidance-text"
                >4. Two 3m building can be transported on a 6m truck</span
              ><br />
              <span class="guidance-text"
                >5. Classroom transport price calculated automatically</span
              ><br />
              <span class="guidance-text"
                >6. The transport price has been provided as an estimate, please
                contact a Kwikspace representative for discounted rates, where
                units can be placed on combined load/truck sizes.</span
              >
            </div>
          </div>

          <!-- <div class="row justify-content-center mt-3 mb-3"
                        *ngIf="showTemplateOption && createdQuote.shipping && !addSecondTransportLoad">
                        <div class="col-sm-12 d-flex justify-content-center">
                            <button type="button" class="btn btn-primary truck-btn" (click)="addAnotherTruck()">
                                <span>Add another truck</span>
                            </button>
                        </div>
                    </div> -->
        </form>
      </ng-container>

      <ng-container
        *ngIf="
          projectSelected &&
          showTransport &&
          createdQuote.shipping &&
          hasShipping
        "
      >
        <div class="form-group">
          <label class="control-label" for="transport_load"
            >Load/Unit Size</label
          >
          <select
            class="form-control"
            formControlName="transport_load"
            id="transport_load"
            (change)="setSelectedTransportLoad()"
          >
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let size of transportLoads" [ngValue]="size.id">
              {{ size.size }}
            </option>
          </select>
        </div>
      </ng-container>

      <ng-container *ngIf="projectSelected && qtyEntered">
        <tan-loader
          [loading]="fpProjectPriceListLoading$ | async"
          [loadingText]="'<p>Loading project price</p>'"
        >
        </tan-loader>

        <tan-loader
          [loading]="addingToCart"
          [loadingText]="'<p>Adding project to cart</p>'"
        >
        </tan-loader>

        <div
          class="row justify-content-center"
          *ngIf="
            !(fpProjectPriceListLoading$ | async) &&
            (fpProjectPriceListError$ | async)
          "
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message
              [errorType]="'error'"
              [message]="'Could not retrieve project price'"
            >
            </tan-alert-message>
          </div>
        </div>

        <div
          class="row justify-content-center mt-3 mb-3"
          *ngIf="hasProjectPricing"
        >
          <div class="col-sm-12 d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-primary action-btn"
              (click)="addToCart()"
            >
              <span>Add to Cart</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-md-4 col-sm-12">
      <div class="container custom-section">
        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="section-heading">Quote Cart</span>
          </div>
        </div>
        <div class="row" *ngIf="quoteCart.length == 0">
          <div class="col-sm-12">
            <tan-alert-message
              [errorType]="'info'"
              [message]="'No items in cart yet'"
            ></tan-alert-message>
          </div>
        </div>
        <div class="row" *ngIf="quoteCart.length > 0">
          <div class="col-sm-12">
            <ng-container *ngFor="let item of quoteCart">
              <div class="row">
                <label class="col-sm-10 col-form-label">
                  {{ item.unit }}
                </label>
                <div class="col-sm-2">
                  <button
                    type="button"
                    class="btn btn-primary remove ml-1"
                    (click)="openRemoveUnitModal(item)"
                  >
                    <span><i class="fa fa-trash"></i></span>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <span><strong>Project</strong></span>
                </div>
                <div class="col-sm-6">
                  <span><strong>Quantity</strong></span>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  {{ item.name }}
                </div>
                <div class="col-sm-6">
                  {{ item.quantity }}
                </div>
              </div>

              <!-- <ng-container *ngIf="item.mappedProducts.length > 0">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="col-form-label">Included Items</label>
                                    </div>
                                </div>
                                <ng-container *ngFor="let extra of item.mappedProducts">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            {{ extra.name }}
                                        </div>
                                        <div class="col-sm-6">
                                            {{ extra.qty }}
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container> -->

              <ng-container *ngIf="item.transportOne">
                <div class="row">
                  <div class="col-sm-12">
                    <label class="col-form-label">Delivery Charges</label>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-sm-12">
                    Delivery -
                    {{
                      item.transportOne.transport.transportLocation.district
                        .province.name
                    }}
                    -
                    {{ item.transportOne.transport.transportLocation.name }}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="item.transportJoin">
                <div class="row mb-3">
                  <div class="col-sm-12">
                    Travel & Siting -
                    {{
                      item.transportJoin.transport.transportLocation.district
                        .province.name
                    }}
                    -
                    {{ item.transportJoin.transport.transportLocation.name }}
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <div class="row" *ngIf="canSave">
              <div class="col-sm-12">
                <div class="pt-2 pb-2 ar">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="completeQuote(); saveQuote.disabled = true"
                    #saveQuote
                  >
                    <span
                      *ngIf="
                        !(createLineItemLoading$ | async) &&
                        !(createLineItemConfigLoading$ | async)
                      "
                      >Save</span
                    >
                    <span
                      *ngIf="
                        (createLineItemLoading$ | async) ||
                        (createLineItemConfigLoading$ | async)
                      "
                      ><i class="fa fa-spinner fa-spin"></i>Saving</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container custom-section"
  *ngIf="
    !showProjectsTable &&
    selectedFpProjectSize &&
    selectedFpProjectSubCategory &&
    selectedFpProjectCategory &&
    selectedFpProjectExtra
  "
>
  <div class="row justify-content-center">
    <div class="col-sm-12 d-flex justify-content-center mt-3">
      <tan-alert-message
        [errorType]="'info'"
        [message]="
          'Could not find a project that matches your criteria. Create your own below.'
        "
      >
      </tan-alert-message>
    </div>
  </div>

  <div
    class="col-sm-12 d-flex justify-content-center"
    *ngIf="!(isMobile | async)"
  >
    <tan-alert-message
      [errorType]="'info'"
      [message]="'Could not find what you are looking for? Please contact us!'"
    >
    </tan-alert-message>
    <!-- <button
      type="button"
      class="btn btn-secondary"
      (click)="confirmUnitSizesClick($event)"
    >
      Create new
    </button> -->
  </div>
</div>

<tan-modal
  #confirmUnitSizes
  [size]="'lg'"
  [title]="'Make sure to use the following sizes'"
  [showInformationBlock]="false"
  (onSave)="createDiagramClick()"
  [actionButtonLabel]="'Ok'"
>
  <div modal-content>
    <div class="container">
      <span *ngFor="let unitSize of unitSizes">
        <span class="col-3 sizes"> {{ unitSize.size.size }} </span>
      </span>
    </div>
  </div>
</tan-modal>

<!-- <div
    *ngIf="!projectOptionsSelected && selectedFpProjectSize && selectedFpProjectSubCategory && selectedFpProjectCategory && selectedFpProjectExtra">
    <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center mt-3">
            <tan-alert-message [errorType]="'error'" [message]="'Could not find templates!'">
            </tan-alert-message>
        </div>
    </div>

    <div class="col-sm-12 col-md-6" *ngIf="!(isMobile | async)">
        <button type="button" class="btn btn-secondary btn-sm" (click)="createDiagramClick($event)">
            Create new
        </button>
    </div>
</div> -->

<!-- <tan-modal #addProjectQtyModal [size]="'sm'" [title]="'Select quantity'" [showInformationBlock]="false"
    (onSave)="addToCart()">
    <div modal-content>
        <div class="container">
            <div class="row mt-3">
                <div class="col-sm-12">
                    <form class="mt-2" [formGroup]="purchaseQtyForm">
                        <div class="row mt-2">
                            <div class="form-group">
                                <label class="control-label" for="quantity">* Quantity</label>
                                <input type="text" class="form-control" formControlName="quantity" [value]="unitQty"
                                    (ngModelChange)="setUnitQty()" />
                                <span class="error"
                                    *ngIf="purchaseQtyForm.get('quantity').touched && purchaseQtyForm.get('quantity').errors?.required">
                                    qty is required</span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</tan-modal> -->

<tan-modal
  #viewProjectImgModal
  [size]="'xl'"
  [title]="'Project Visualisation'"
  [showInformationBlock]="false"
  [showActionButton]="false"
>
  <div modal-content>
    <div class="container" *ngIf="projectToView">
      <div class="row mt-3">
        <!-- <div class="col-sm-6">
                    <ng-container *ngIf="projectToView.thumbnail != null">
                        <div class="row">
                            <div class="col-sm-12">
                                <h4 class="mb-3">2D</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 d-flex justify-content-center">
                                <img [src]="projectToView.thumbnail">
                            </div>
                        </div>
                    </ng-container>
                </div> -->
        <div class="col-sm-12">
          <ng-container *ngIf="projectToView.thumbnail3d != null">
            <div class="row">
              <div class="col-sm-12">
                <h4 class="mb-3">3D Image</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 d-flex justify-content-center">
                <img [src]="projectToView.thumbnail3d" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- <div class="row">
                <div class="col-sm-12">
                    <span>Items included in this selection:</span>
                </div>
            </div> -->
      <!-- <div class="row">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-6">
                            Item
                        </div>
                        <div class="col-sm-6">
                            Quantity
                        </div>
                    </div>
                    <div class="row" *ngFor="let product of projectProducts">
                        <div class="col-sm-6">
                            {{ product.name }}
                        </div>
                        <div class="col-sm-6">
                            {{ product.qty }}
                        </div>
                    </div>
                </div>
            </div> -->
    </div>
  </div>
</tan-modal>

<tan-modal
  #removeUnitModal
  [size]="'lg'"
  [title]="'Please confirm'"
  [showInformationBlock]="false"
  (onSave)="removeUnit()"
>
  <div modal-content>
    <div class="container">
      <ng-container *ngTemplateOutlet="confirmRemoveUnitContent"></ng-container>
    </div>
  </div>
</tan-modal>

<ng-template #confirmRemoveUnitContent>
  <ng-container
    *ngIf="selectedModalLineItem != null && selectedModalLineItemExtra == null"
  >
    <p>
      Are you sure you want to remove <b>{{ selectedModalLineItem.name }}</b
      >?
    </p>
    <div class="mt-3">
      <label>Purchase Price:</label><br />
      <span>{{ selectedModalLineItem.price }}</span>
    </div>
    <div class="mt-3">
      <label>Size:</label><br />
      <span>{{ selectedModalLineItem.size }}</span>
    </div>
  </ng-container>
</ng-template>
